// extracted by mini-css-extract-plugin
export default {"carousel":"carousel_carousel__eClNW","navigation":"carousel_navigation__wtWXp","nav-button":"carousel_nav-button__vYA2b"};